import BuyBoxTab from './Components/BuyBoxTab';
import BuyerInfoTab from './Components/BuyerInfoTab';
import BuyerVerificationTab from './Components/BuyerVerificationTab';
import { DealsTab } from './Components/DealsTab';
import { PreDealsTab } from './Components/PreDealsTab';

export const getTabs = ({
  props,
  selectedBuyer,
  changedParams,
  setChangedParams,
  params,
  setParams,
  revertChangesHandler,
}) => [
  {
    key: 'info',
    label: 'Info',
    children: (
      <BuyerInfoTab
        selectedBuyer={selectedBuyer}
        changedParams={changedParams}
        setChangedParams={setChangedParams}
        params={params}
        setParams={setParams}
        revertChangesHandler={revertChangesHandler}
      />
    ),
  },
  {
    key: 'buybox',
    label: 'Buy Box',
    children: <BuyBoxTab {...props} />,
  },
  {
    key: 'verification',
    label: 'Verification',
    children: <BuyerVerificationTab selectedBuyer={selectedBuyer} />,
  },
  {
    key: 'deals',
    label: 'Deals Stats',
    children: (
      <DealsTab organizationId={selectedBuyer?.defaultOrganization?._id} />
    ),
  },
  {
    key: 'preDeals',
    label: 'Pre-Deals Stats',
    children: (
      <PreDealsTab organizationId={selectedBuyer?.defaultOrganization?._id} />
    ),
  },
];

// AGENT_OPTIONS moved to dynamic data from Redux store
// Use agents from UserReducer instead of hardcoded values
